




































import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import Project from '@/models/Project.ts'
import UserGroup from '@/models/UserGroup.ts'
import User from '@/models/User.ts'
import ProjectListing from './projects/Listing.vue'
import CenteredSpinner from '@/components/CenteredSpinner.vue'
import { IsProjectHidden } from '@/util/LocalProjectHiding'

@Component({
	components:
	{
		ProjectListing,
		CenteredSpinner
	},
    computed: 
	{
		...mapGetters([
			'projects'
		])
	}
})
export default class EditMapModalContent extends Vue
{
	currentRequest = 0;
	loadingProjectList = false;
	loadingProjectUsers = false;

	get projectsList()
	{
		return (this as any).projects.values();
	}

	get loadingComplete()
	{
		return !this.loadingProjectList && !this.loadingProjectUsers;
	}

	async refresh()
	{
		// This is to prevent a race condition if refresh is called
		// more than once.
		let req = ++this.currentRequest;

		this.loadingProjectList = true;
		this.loadingProjectUsers = true;
		this.$store.commit('clearProjects');
		try
		{
			let res = await this.$http.get("getprojects");
			if (req != this.currentRequest) return;

			this.loadingProjectList = false;

			res.data.projects.sort((a : Project, b : Project) =>
			{
				// numeric == natural sort, base sensitivity == case insensitive
				return a.name.trim().localeCompare(b.name.trim(), undefined, {numeric: true, sensitivity: 'base'});
			});

			// Duplicating it so that hidden projects can be loaded after
			let arr: Project[] = res.data.projects.slice();
			arr.sort((a : Project, b : Project) =>
			{
				const ahidden = IsProjectHidden(a);
				const bhidden = IsProjectHidden(b);
				
				// Ensure that hidden projects are sorted after visible ones
				if (ahidden != bhidden)
				{
                    return ahidden ? 1 : -1;
				}
				
				// numeric == natural sort, base sensitivity == case insensitive
				return a.name.trim().localeCompare(b.name.trim(), undefined, {numeric: true, sensitivity: 'base'});
			});

			let pendingTasks: (()=>Promise<any>)[] = [];
			let tasks: Promise<any>[] = [];
			for (let i = 0; i < arr.length; ++i)
			{
				let prj = new Project();
				Object.assign(prj, arr[i]);
				this.$store.commit('setProjectInList', { p: prj });

				pendingTasks.push(()=>this.$http.get(`getprojectusergroups?pid=${prj.id}`).then(
					async (resp)=>{
						if (req != this.currentRequest) return;
						if (resp.data.error)
						{
							alert(resp.data.error);
							return;
						}
						try
						{
							this.$set(prj, "groups", resp.data.groups);
							this.$set(prj, "group", prj.groups.find((g)=>g.id == resp.data.group));
							// console.log(prj.group);
							this.$store.commit('setProjectInList', { p: prj });
							(this.$refs.listings as any).forEach((l : any) => l.$forceUpdate()); // TODO: this is stupid
						}
						catch(ex)
						{
							console.error(ex);
							if (ex.response.status == 401)
							{
								this.$set(prj, 'groupError', "You do not have access to this project");
								//this.$set(prj, 'group', null);
								//this.$forceUpdate();
								return;
							}

							alert(`Projects.vue: ${ex}`);
						}
					},
					(err)=>{
						alert(`failed to get usergroups for [${prj.id}] ${prj.name}`);
					}
				));
			}

			for(let i = 0; i < pendingTasks.length; ++i)
			{
				tasks.push(pendingTasks[i]());

				// Rate limiter
				if (tasks.length > 7)
				{
					await Promise.all(tasks);
					
					if (req != this.currentRequest) return;
					tasks.length = 0;
				}

			}
			
			for(let k of tasks)
			{
				await k;
				if (req != this.currentRequest) return;
			}
		}
		catch(err)
		{
			alert(err.response.data);
		}
		this.loadingProjectList = false;
		this.loadingProjectUsers = false;
		this.$emit("refresh-complete");
	}

	async createSampleProject()
	{
		let resp = await this.$http.post('projects/sample');
		await this.refresh();
	}

	mounted()
	{
		this.refresh();
	}
}
